import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

function Copyright() {
    const urlParams = new URLSearchParams(window.location.search);
    const noCopyright = urlParams.get('nocopy');

    if(!!noCopyright) {
        return (null);
    }

    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="http://livevideo.com.ua/">
                LiveVideo
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default Copyright;